import { render, staticRenderFns } from "./DeliveryZonesReport.vue?vue&type=template&id=65177a71&scoped=true"
import script from "./DeliveryZonesReport.vue?vue&type=script&lang=js"
export * from "./DeliveryZonesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65177a71",
  null
  
)

export default component.exports